import React from "react";
import { formatNumber } from "../selectors";

const LEVELS = 4;

function levelOf(value, max) {
  if (!value || !max) {
    return 0;
  }

  return Math.max(1, Math.ceil((value / max) * LEVELS));
}

function dayLabel(dayKey) {
  return new Date(`${dayKey}T12:00:00Z`).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
  });
}

/**
 * One cell per day, darker for more actions. `max` is shared by every row of a
 * table so people can be compared at a glance.
 */
export function ActivityStrip({ days, values, max, label }) {
  const activeDays = values.filter((value) => value > 0).length;
  const total = values.reduce((sum, value) => sum + value, 0);

  return (
    <span className="pl-strip">
      <span className="pl-sr-only">
        {label}: active {activeDays} of {values.length} days, {formatNumber(total)} actions.
      </span>
      {values.map((value, index) => (
        <span
          key={days[index]}
          className={`pl-strip-cell pl-strip-cell--${levelOf(value, max)}`}
          title={`${dayLabel(days[index])}: ${formatNumber(value)} actions`}
          aria-hidden="true"
        />
      ))}
    </span>
  );
}
